module.exports = __webpack_public_path__ + "img/space.0782120b.png";